import { render, staticRenderFns } from "./CFormComponent.vue?vue&type=template&id=51d0229a&scoped=true&"
import script from "./CFormComponent.vue?vue&type=script&lang=js&"
export * from "./CFormComponent.vue?vue&type=script&lang=js&"
import style0 from "./CFormComponent.vue?vue&type=style&index=0&id=51d0229a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51d0229a",
  null
  
)

export default component.exports